import { html as a, when as r, ref as l } from "@microsoft/fast-element";
const e = {
  primary: "information-circle",
  error: "exclamation-triangle",
  success: "check-circle"
}, d = (s) => {
  const o = a.partial(s.prefix);
  return a`
    <div class="positioning-region" part="positioning-region">
      ${r(
    (i) => i.modal,
    a`
          <div
            class="overlay"
            part="overlay"
            role="presentation"
            @click="${(i) => i.dismissible ? i.dismiss() : ""}"
          ></div>
        `
  )}
      <div
        role="dialog"
        tabindex="-1"
        class="control"
        part="control"
        aria-modal="${(i) => i.modal ? i.modal : ""}"
        aria-describedby="${(i) => i.ariaDescribedby}"
        aria-labelledby="${(i) => i.ariaLabelledby}"
        aria-label="${(i) => i.ariaLabel}"
        ${l("dialog")}
      >
        ${r(
    (i) => i.dismissible,
    a`
          <${o}-button class="dismiss-dialog" variant="ghost" color="neutral" @click="${(i) => i.dismiss()}">
            <${o}-icon slot="start" name="x-mark">
          </${o}-button>
        `
  )}
        <div class="dialog-header">
          <${o}-icon
            name="${(i) => e[i.color]}"
            color="${(i) => i.color}"
            variant="solid"
          ></${o}-icon>
          <slot name="header"></slot>
        </div>
        <div class="dialog-body" ${l("_dialogBody")}>
          <slot></slot>
        </div>
        <div class="dialog-footer" ${l("_dialogFooter")}>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  `;
};
export {
  d as dialogTemplate
};
